module.exports = __webpack_public_path__ + "static/media/performance.9e8fb27b.svg";